/**
 * カートページの初期化処理
 * 資料請求リストとレコメンドの取得および表示を行う
 */
$(function(){
	_getDetailList();
	_eventHandlerUpdateFooterRecommend();
});

var recommendFirstShowFlg = 0;
var cartFirstShowFlg = 0;

// レコメンドを取得したかどうかのフラグ
var recommendListInit = false;

// 最後に取得したレコメンドのデフォルトチェックフラグ(初回は空にしておく)
var defaultCheckFlg = null;

/**
 * フッターレコメンドエリアの変更イベントを登録する
 * 非同期取得されるフッターレコメンドに対してカート追加イベントを設定
 */
function _eventHandlerUpdateFooterRecommend() {
	$(document).on('change', '#new-footer-recommend', function(){
		_eventHandlerAddCart();
	});
}

/**
 * 資料請求リスト情報を取得してカート画面を更新する
 * レコメンドとイベントハンドラの初期化も行う
 */
function _getDetailList(){
	// セッションからカート削除済みの教室IDを取得
	var deleteCartKousha = sessionStorage.getItem('deleteCartKousha');
	// セッションから取得できた場合はカスタム変数に追加
	if(deleteCartKousha != null){
		$('input[name="delete_kousha"]').val(deleteCartKousha);
	}

	$.getJSON('/cart/get_detail_list/', function(response){
		$("#js-cart-list").html(response.view);
		$("#js-footer-recommend").html(response.cart_footer_view);

		// デフォルトチェックの有無で表示非表示を切り替え
		if (defaultCheckFlg == 1) {	
			$("#js-cart-list").find('.js-dft-reco-hide').hide();
		} else {
			$("#js-cart-list").find('.js-dft-reco-hide').show();
		}

		// レコメンドチェックされているものは、レコメンドのほうで表示されているため削除
		$('.js-cart-recommend-area').find('.js-chk-kousha:checked').each(function(i,val){
			let kousha_id = $(val).attr('kousha_id');
			if ($('#cart_list').find('tr[data-kousha_id=' + kousha_id + ']').length) {
				$('#cart_list').find('tr[data-kousha_id=' + kousha_id + ']').remove();
			}
		});

		_listReplaceCallback();
	})
	.done(function(response) {
		let cart_kousha = $('.cart_reco_cart_kousha').val();
		let cart_tutor = $('.cart_reco_cart_tutor').val();
		
		_eventHandlerForm();
		_eventHandlerHistoryBack();
		_eventHandlerDeleteCart();
		if ((cart_kousha && cart_kousha.length > 0) || (cart_tutor && cart_tutor.length > 0)) {
			if(recommendListInit === false) {
				_getRecommendList(cart_kousha, cart_tutor);
				recommendListInit = true;
			}
		} else {
			_eventHandlerHistorySlider();
			trackEvent.initialize();
			if (recommendFirstShowFlg == 0) {
				ecommerce.initialize();
			}
			recommendFirstShowFlg = parseInt(recommendFirstShowFlg) + 1;
		}
		_eventHandlerAddCart();
		_eventHandlerPopup();
		_eventHandlerChangeKousha();
		_initializeRadioButton();
		
	});
}

/**
 * レコメンド情報をサーバーから取得して表示する
 * カートに入っている校舎・家庭教師情報を元にレコメンドを生成
 */
function _getRecommendList(cart_kousha, cart_tutor){
	// sessionStorageにno_cart_recommend=trueが入ってる場合はカートレコメンドは不要なので取りにいかないようにする
	if (sessionStorage.getItem('no_cart_recommend') != 'true') {
		let obj = {};
		// カスタム変数
		$('.wt_recommend-cv').each(function(){
			obj[$(this).attr('name')] = $(this).val();
		});
		// カスタムソート変数
		$('.wt_recommend-sc').each(function(){
			obj[$(this).attr('name')] = $(this).val();
		});

		obj['cart_kousha'] = cart_kousha;
		obj['cart_tutor'] = cart_tutor;
		obj['history_kousha'] = $('.cart_reco_history_kousha').val();
		obj['cv_kousha'] = $('.cart_reco_cv_kousha').val();
		obj['via_page'] = $('input[name=via_page]').val();
		obj['list_name'] = $('#new-cart-recommend').data('list_name');

		// サーバーサイドからレコメンドを取得
		$.ajax({
			type: "POST",
			url: '/recommend/get_cart_list/',
			datatype: 'json',
			data: {
				is_json: 1,
				json_data:JSON.stringify(obj)
			}
		}).done(function(res) {
			if (res.list_num > 0) {
				$('#new-cart-recommend').html(res.response);
			} else {
				// レコメンド件数が無い場合は要素を空にする（空にしないとレコメンドの最後を追加した時に消えずに表示され続けてしまう）
				$('#new-cart-recommend').html('');

				// デフォルトチェックも初期化
				defaultCheckFlg = null;
			}
			// デフォルトチェックの有無で表示非表示を切り替え
			defaultCheckFlg = res.defaultCheckFlg
			_listReplaceCallback();

			_eventHandlerAddCart();
			_eventHandlerForm();
			_eventHandlerHistoryBack();
			_eventHandlerRecommendSlider();
			trackEvent.initialize();
			if (recommendFirstShowFlg == 0) {
				ecommerce.initialize();
			}
			recommendFirstShowFlg = parseInt(recommendFirstShowFlg) + 1;
		});
	}
}

/**
 * カートリストまたはレコメンドリスト書き換え時の共通処理
 * 外部遷移時のEコマース送信とデフォルトチェック制御を行う
 */
function _listReplaceCallback(){
	if (cartFirstShowFlg == 0) {
		//外部からの遷移かつYlocoの場合はEコマースでカート追加送信
		_sendEcFromOuterTransition();
		cartFirstShowFlg =  parseInt(cartFirstShowFlg) + 1;
	}
	// デフォルトチェックの有無で表示非表示を切り替え
	if (defaultCheckFlg == 1) {	
		$("#js-cart-list").find('.js-dft-reco-hide').hide();
	} else {
		$("#js-cart-list").find('.js-dft-reco-hide').show();
	}
}

/**
 * 資料請求フォームへの遷移ボタンクリックイベントを登録する
 * 選択チェック・件数制限バリデーションを実行してフォーム送信
 */
function _eventHandlerForm() {
	// ヘッダーロゴのイベント登録を一度抹消し、
	// _getRecommendListのtrackEvent.initialize()で再登録。
	// そうしないとヘッダーロゴのtrack_eventが多重登録される。
	$('.mod-head-logo').unbind();
	$('.js-cart-button').unbind();
	$('.js-cart-button').on('click', function(){
		var koushaIds = [];
		var jukuIds = [];
		var areaCallIds = [];
		var radioNoSelect = false;
		$('[id^=js-check-juku-], [id^=js-default-check-juku-]').each(function(i,val){
			if($(this).val() != '' && $(this).prop('checked')){
				koushaIds.push($(this).val());
				jukuIds.push($(this).attr('juku_id'));
			}else{
				// 教室にチェックが入っていなければエラー文言とラジオボタンを赤くする
				if($('.js-cart-list-radio-' + $(this).attr('juku_id')).length > 0){
					$('.js-cart-list-notice-' + $(this).attr('juku_id')).addClass('cart-list-notice_error');
					$('.js-cart-list-radio-' + $(this).attr('juku_id')).addClass('cart-list-radio__error');
					radioNoSelect = true;
				}
			}
		});

		if (defaultCheckFlg == '1') {
			// デフォルトチェック用レコメンドの場合は遷移ボタンクリック時に一括でEコマースのカート追加イベントを送信する
			_sendECommerceAddCart();
		} else {
			// デフォルトチェックでないとき
			// レコメンドの校舎を追加する
			$('.js-cart-recommend-area').find('.js-reco-ec-checkbox:checked').each(function(i,val){
				// 校舎idを格納
				koushaIds.push($(this).attr("kousha_id"));
			});
		}

		// 教室にチェックが入っていない塾があれば遷移しない
		if(radioNoSelect == true){
			alert('1つの塾につき、1教室のみ資料請求可能です。いずれかの教室を選択してください。');
			return;
		}
		$('[id^=js-check-tutor-][value!=""]:checked, [id^=tutor_][value!=""]:checked').each(function(i,val){
			areaCallIds.push($(this).val());
		});
		if (koushaIds.length>20) {
			alert('一度に資料請求が行える教室は20件までとなっております。現在' + koushaIds.length + '件選択しています。');
			return;
		}
		if (areaCallIds.length>5) {
			alert('一度に資料請求が行える家庭教師センターは5件までとなっております。現在' + areaCallIds.length + '件選択しています。');
			return;
		}
		$('input[name="kousha_id"]').val(koushaIds.join());
		$('input[name="juku_ids"]').val(jukuIds.join());
		$('input[name="area_call_id"]').val(areaCallIds.join());
		
		$('#js-cart-form').submit();
	});
}

/**
 * 外部連携先からのカート遷移時にEコマースのカート追加イベントを送信する
 * PCカートは非同期でカートリストを取得するためJavaScriptで処理
 */
function _sendEcFromOuterTransition() {
	//Ylocoの場合はEコマースでカート追加送信
	var isYloco = ( $('input[type=hidden][name=yloco]').val() == 1);
	if(isYloco){
		$('.main').append('<!-- ecommerce.sendEcAddCartFromOuterTransition --><input type="hidden" class="js-ec-send-outer-transition">');
		try{
			if (typeof ecommerce == 'undefined') {
				ecommerce = new EcommerceManager();
			}
			ecommerce.sendEcAddCartFromOuterTransition();
		}catch(e){

		}
	}
}

/**
 * 校舎詳細ポップアップの表示イベントを登録する
 */
function _eventHandlerPopup() {
	$('.js-cart-modal-window-open').on('click', function(){
		$('.js-cart-modal-window-' + $(this).attr('juku_id') + '-' + $(this).attr('kousha_id')).trigger('click');
	});
}

/**
 * カート追加・削除ボタンのクリックイベントを登録する
 * チェックボックスのON/OFFでカート追加・削除を制御
 */
function _eventHandlerAddCart() {
	$('.js-add-cart').unbind();
	$('.js-add-cart').on('click', function(){
		// デフォルトチェック用レコメンドの場合はチェックON・OFF時は何もしない
		if (defaultCheckFlg == '1') {
			return;
		}

		//クリックでチェックが付いたorチェックボックスではない追加ボタンの場合は追加処理
		if ($(this).is(':checked') || $(this).is(':not(input)')) {
			_addCartHandler($(this));
		//それ以外の場合は削除処理（チェックボックス用）
		} else {
			_processDeleteCart(this);
		}
	});
}

/**
 * カート追加処理を実行する
 * Ajax通信でサーバーにカート追加リクエストを送信しEコマースイベントも発火
 */
function _addCartHandler($target) {
	//送信データ作成
	const listName = ($target.attr('list_name') != undefined)? $target.attr('list_name') : 'CartPageAdd';
	const listPosition = ($target.attr('list_position') != undefined)? $target.attr('list_position') : '';
	var data = {
		'kousha' : {
			'kousha_id' : $target.attr('kousha_id')
		},
		'tutor_pref' : {
			'tutor_id' : $target.attr('tutor_id'),
			'pref_cd' : $target.attr('pref_cd')
		},
		'list_name' : listName,
		'index' : listPosition
	};
	$.ajax({
		type: "POST",
		url: "/cart/add/",
		data: {
			is_json: 1,
			json_data : JSON.stringify(data)
		},
		dataType: "json",
		success: function(response){
			// 拡張eコマース用データセット
			var ecItemList = [];
			if (response.detail_data[0] != null) {
				$.each(response.detail_data, function(i, val) {
					var ecItem = {
						'item_id': 'b' + val.Juku.juku_id + '_' + 'k' + val.Kousha.kousha_id,
						'item_brand': 'b' + val.Juku.juku_id,
						'item_category': 'p' + val.Kousha.pref_cd,
						'price': 4000,
						'currency': 'JPY',
						'item_list_name': listName,
						'index': listPosition,
						'quantity': 1
					};
					ecItemList.push(ecItem);
				});
			} else if (response.detail_data.Tutor != null) {
				var ecItem = {
					'item_id': 't' + response.detail_data.Tutor.id + '_p' + response.detail_data.TutorPrefecture.cd,
					'item_brand': 't' + response.detail_data.Tutor.id,
					'item_category': 'p' + response.detail_data.TutorPrefecture.cd,
					'price': 4000,
					'currency': 'JPY',
					'item_list_name': listName,
					'index': listPosition,
					'quantity': 1
				};
				ecItemList.push(ecItem);
			}
			gtag('event', 'add_to_cart', {
				'currency': 'JPY',
				'value': 4000,
				'items': ecItemList
			});

			gtag('event', 'cart', {
				"TheEventAction": "cart",
			});
			if (response.success) {
				// カート追加時に、カート情報表示されていない場合は、カートとレコメンドを再取得
				if($('.js-cart-recommend-area').find('.js-add-cart:checked').length + $('#cart_list .js-chk-kousha, #cart_list .js-chk-tutor').length == 0){
					// レコメンドも再取得するように変更
					recommendListInit = false;
					// 現状資料請求リストがないときは更新する
					_getDetailList();
				}
			} else {
				//サーバー側処理失敗時
				alert('資料請求リストへの追加に失敗しました。お手数ですが再度お試しください。');
			}
		},
		error: function() {
			//通信失敗時の処理
			alert('通信失敗');
		}
	});
}

/**
 * カート削除ボタンのクリックイベントを登録する
 */
function _eventHandlerDeleteCart() {
	$('.js-delete-cart').on('click', function(){
		_processDeleteCart(this);
	});
}

/**
 * 削除ボタン押下時に資料請求リスト情報を再取得する
 * カート件数に応じてレコメンド再取得も制御
 */
function _getDetailListOnDelete(){
	$.getJSON('/cart/get_detail_list/', function(response){

		// カートリスト表示
		$("#js-cart-list").html(response.view);

		// フッター部分を表示
		$("#js-footer-recommend").html(response.cart_footer_view);

		// デフォルトチェックの有無で表示非表示を切り替え
		if (defaultCheckFlg == 1) {	
			$("#js-cart-list").find('.js-dft-reco-hide').hide();
		} else {
			$("#js-cart-list").find('.js-dft-reco-hide').show();
		}

		// レコメンドチェックされているものは、レコメンドのほうで表示されているため削除
		$('.js-cart-recommend-area').find('.js-add-cart:checked').each(function(i,val){
			if ($(val).hasClass('js-chk-kousha')) {
				let kousha_id = $(val).attr('kousha_id');
				if ($('#cart_list').find('tr[data-kousha_id=' + kousha_id + ']').length) {
					$('#cart_list').find('tr[data-kousha_id=' + kousha_id + ']').remove();
				}
			} else {
				// 家庭教師
				let tutor_id = $(val).attr('tutor_id');
				if ($('#cart_list').find('tr[data-tutor_id=' + tutor_id + ']').length) {
					$('#cart_list').find('tr[data-tutor_id=' + tutor_id + ']').remove();
				}
			}
		});

		_listReplaceCallback();
	})
	.done(function(response) {
		let cart_kousha_list = $('.cart_reco_cart_kousha').val();
		let cart_tutor_list = $('.cart_reco_cart_tutor').val();

		_eventHandlerForm();
		_eventHandlerHistoryBack();
		_eventHandlerDeleteCart();
		_eventHandlerPopup();
		if(response.datas.cart.total == 0){
			// レコメンドを無くすため、再取得処理を実行
			_getRecommendList(cart_kousha_list, cart_tutor_list);

			// ヒストリーのスライダーを再登録
			_eventHandlerHistorySlider();
		} else {
			trackEvent.initialize();
			if (recommendFirstShowFlg == 0) {
				ecommerce.initialize();
			}
			recommendFirstShowFlg = parseInt(recommendFirstShowFlg) + 1;
		}
		_eventHandlerAddCart();
		_eventHandlerChangeKousha();
		_initializeRadioButton();
		_updateCartCookie();
	});
}

/**
 * カート削除処理を実行する
 * Ajax通信でサーバーに削除リクエストを送信しEコマースイベントも発火
 */
function _processDeleteCart(scope){
	//送信データ作成
	let data = {
		'kousha' : {
			'kousha_id' : $(scope).attr('kousha_id')
		},
		'tutor_pref' : {
			'tutor_id' : $(scope).attr('tutor_id'),
			'pref_cd' : $(scope).attr('pref_cd')
		}
	};
	let listName = ($(scope).attr('list_name') != undefined)? $(scope).attr('list_name') : 'CartPageAdd';
	let listPosition = ($(scope).attr('list_position') != undefined)? $(scope).attr('list_position') : '';

	// カート削除した教室IDを取得
	let deleteKoushaId = $(scope).attr('kousha_id');
	if(deleteKoushaId){
		let deleteCartList = [];
		// セッションから一度カート削除した教室IDを取得
		let deleteCartKousha = sessionStorage.getItem('deleteCartKousha');
		// カート削除した教室IDリスト（複数教室の場合があるため配列に格納）
		let koushaIdList = deleteKoushaId.split(',');
		if(deleteCartKousha != null){
			// セッションから教室IDが取得できた場合、既に同じ教室IDが入っていないかチェック
			deleteCartList = deleteCartKousha.split(',');
			$.each(koushaIdList, function(index, val) {
				if($.inArray(val, deleteCartList) == -1){
					deleteCartList.push(val);
				}
			});
		} else {
			// セッションから教室IDが取得できない場合
			deleteCartList = koushaIdList;
		}
		// 最大20件になるよう配列の先頭から削除（カスタム変数の値は最大20件のため）
		if(deleteCartList.length > 20) {
			deleteCartList.splice(0, deleteCartList.length - 20);
		}
		// セッションに追加
		sessionStorage.setItem('deleteCartKousha', deleteCartList.join(','));
		// カスタム変数更新
		$('input[name="delete_kousha"]').val(sessionStorage.getItem('deleteCartKousha'));
	}

	$.ajax({
		type: "POST",
		url: "/cart/delete/",
		data: {
			is_json: 1,
			json_data : JSON.stringify(data)
		},
		dataType: "json",
		success: function(response){
			if (response.success) {
				
				// 拡張eコマース用データセット
				let ecItemList = [];
				if (response.detail_data[0] != null) {
					$.each(response.detail_data, function(i, val) {
						let ecItem = {
							'item_id': 'b' + val.Juku.juku_id + '_' + 'k' + val.Kousha.kousha_id,
							'item_brand': 'b' + val.Juku.juku_id,
							'item_category': 'p' + val.Kousha.pref_cd,
							'price': 4000,
							'currency': 'JPY',
							'item_list_name': listName,
							'index': listPosition,
							'quantity': 1
						};
						ecItemList.push(ecItem);
					});
				} else if (response.detail_data.Tutor != null) {
					let ecItem = {
						'item_id': 't' + response.detail_data.Tutor.id + '_p' + response.detail_data.TutorPrefecture.cd,
						'item_brand': 't' + response.detail_data.Tutor.id,
						'item_category': 'p' + response.detail_data.TutorPrefecture.cd,
						'price': 4000,
						'currency': 'JPY',
						'item_list_name': listName,
						'index': listPosition,
						'quantity': 1
					};
					ecItemList.push(ecItem);
				}
				gtag('event', 'remove_from_cart', {
					'currency': 'JPY',
					'value': 4000,
					'items': ecItemList
				});

				gtag('event', 'cart', {
					"TheEventAction": "cart",
				});
				// カート表示
				// カートの件数を取得
				let cartCount = $('#cart_list .js-chk-kousha, #cart_list .js-chk-tutor').length;
				// カートリストの場合は、表示上まだ消えていないため、カート件数を減らして、実態に合わせる
				if($(scope).parents('#cart_list').length == 1) {
					cartCount -= 1
				}

				if (!defaultCheckFlg) {
					// デフォルトチェック出ない場合は、レコメンド箇所のチェック項目もカウント
					cartCount += $('.js-reco-ec-checkbox:checked').length
				}

				// クリック対象がカートリストのとき、またはカート件数が0のときは再取得する
				if( $(scope).parents('#cart_list').length == 1 || cartCount == 0) {
					recommendListInit = false;
					_getDetailListOnDelete();
				}
			} else {
				//サーバー側処理失敗時
				alert('資料請求リストからの削除に失敗しました。お手数ですが再度お試しください。');
			}
		},
		error: function() {
			//通信失敗時の処理
			alert('通信失敗');
		}
	});
}

/**
 * 教室選択ラジオボタンの変更イベントを登録する
 * 選択状態の表示制御とcookie更新を行う
 */
function _eventHandlerChangeKousha() {
	$('.cart-list-spec').on('click', function(){
		$('#r_juku_' + $(this).attr('kousha_id')).prop('checked', true);
		$('#r_juku_' + $(this).attr('kousha_id')).trigger('change');
	});
	$('.js-cart-change-kousha').on('change', function(){
		$('#js-check-juku-' + $(this).attr('juku_id') + ', #js-default-check-juku-' + $(this).attr('juku_id')).val($(this).val()).prop('checked',true);
		$('#js-check-juku-' + $(this).attr('juku_id') + ', #js-default-check-juku-' + $(this).attr('juku_id')).prop('checked',true);
		$('.js-cart-list-notice-' + $(this).attr('juku_id')).removeClass('cart-list-notice_error');
		$('.js-cart-list-radio-' + $(this).attr('juku_id')).removeClass('cart-list-radio__error');
		// cookieを更新
		_updateCartCookie();
		
		// 選択されていない教室はグレーアウトする
		$('.js-radio-juku-' + $(this).attr('juku_id')).each(function() {
			$(this).addClass('cart-list-spec__non');
		});
		$('.js-radio-kousha-' + $(this).val()).removeClass('cart-list-spec__non');
	});
}

/**
 * ラジオボタンの選択状態をcookieから取得して復元する
 */
function _initializeRadioButton() {
	var selected = $.cookie('cart_selected');
	if (selected != undefined && selected != null) {
		selected = selected.split(',');
		for (var i in selected) {
			$('#r_juku_' + selected[i]).prop('checked', true);
			$('#r_juku_' + selected[i]).trigger('change');
		}
	} else {
		// cookieを更新
		_updateCartCookie();
	}
}

/**
 * カート選択教室のcookieを更新する
 * 有効期限は30分
 */
function _updateCartCookie() {
	var selected = [];
	$('.js-cart-change-kousha:checked').each(function() {
		selected.push($(this).val());
	});
	// カート選択教室cookieの有効期限は30分
	var date = new Date();
	date.setTime(date.getTime() + (30 * 1000 * 60));
	$.cookie('cart_selected', selected.join(), {path: '/', expires: date});
}

/**
 * ブラウザバック処理を制御する
 * 同一ドメイン内はhistory.back、外部ドメインからはデフォルトURLに遷移
 */
function _eventHandlerHistoryBack() {
	var ans; //1つ前のページが同一ドメインかどうか
	var bs  = false; //unloadイベントが発生したかどうか
	var ref = document.referrer;
	$(window).bind('unload beforeunload', function(){
		bs = true;
	});
	re = new RegExp(location.hostname, 'i');
	if(ref.match(re)){
		ans = true;
	}else{
		ans = false;
	}
	$('.js-cart-historyback').unbind();
	$('.js-cart-historyback').bind('click', function(){
		var that = this;
		if(ans){
			history.back();
		}else{
			location.href = $(this).attr('default_url');
		}
	});
}

/**
 * デフォルトチェックレコメンドのカート追加Eコマースイベントを送信する
 * CVボタン押下時にまとめて送信（チェックON時には計測不可のため）
 */
function _sendECommerceAddCart() {
	// デフォルトチェックの校舎id取得用
	let kousha_ids = [];
	
	let ecItemList = [];
	$('.js-cart-recommend-area').find('[id^=js-default-check-juku-]:checked').each(function(i,val){
		let ecItem = {
			'item_id': 'b' + $(val).attr('juku_id') + '_k' + $(val).attr('kousha_id'),
			'item_brand': 'b' + $(val).attr('juku_id'),
			'item_category': 'p' + $(val).attr('pref_cd'),
			'price': 4000,
			'currency': 'JPY',
			'item_list_name': $(val).attr('list_name'),
			'index': $(val).attr('list_position'),
			'quantity': 1
		};
		ecItemList.push(ecItem);

		// デフォルトチェックの校舎idを格納
		kousha_ids.push($(this).attr("kousha_id"));
	});

	// デフォルトチェック用のパラメータを使用して資料請求入力ページに校舎id情報送信 ※別途カート追加処理を行うため。
	$('#js-cart-form').append('<input type="hidden" name="dft_kousha_id" value="' + kousha_ids.join() + '">')

	gtag('event', 'add_to_cart', {
		'currency': 'JPY',
		'value': 4000,
		'items': ecItemList
	});
}

/**
 * レコメンドスライダーの前後ボタンクリックイベントを登録する
 * トラッキングイベントを送信
 */
function _eventHandlerRecommendSlider() {
	//mousedownイベントに登録
	$('.bx-prev').mousedown(function(){
		trackEvent.analyticsTracking('cartrecommend_pageback_click', 'click', '');
	});
	$('.bx-next').mousedown(function(){
		trackEvent.analyticsTracking('cartrecommend_pageforward_click', 'click', '');
	});
}

/**
 * ヒストリースライダーを初期化する
 * bxSliderの設定と画像ロールオーバーを適用
 */
function _eventHandlerHistorySlider() {
	//ヒストリースライダー
	$('#js-bxslider-history').bxSlider({
		speed: 1500,
		prevText: '前へ', //前へのテキスト
		nextText: '次へ', //次へのテキスト
		pager: false,
		infiniteLoop: false,
		hideControlOnEnd: true
	});

	// 資料請求を問い合わせる画像のホバー設定
	initRollovers();
}